import React from "react";

import style from "./block.module.scss";
import {ReactComponent as Facebook} from "../assets/icons/facebook.svg";
import {ReactComponent as Twitter} from "../assets/icons/twitter.svg";
import {ReactComponent as Linkedin} from "../assets/icons/linkedin.svg";
import {ReactComponent as Youtube} from "../assets/icons/youtube.svg";
import {defineBlock, smartProps, useEditor, useInspectorControl, useSmartProp, ChildrenBlock} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, TextControl, ToggleControl  } from '@wordpress/components';
import {Menu} from '../shared/menu/index.js';
import classnames from 'classnames';
import Logo from'../assets/logo.png';
import { InnerBlocks } from '@wordpress/block-editor';

function Inspector(){
    const [copyright, setCopyright] = useSmartProp("copyright");
    const [linkedin, setLinkedin] = useSmartProp("linkedin");
    const [youtube, setYoutube] = useSmartProp("youtube");
    const [facebook, setFacebook] = useSmartProp("facebook");
    const [twitter, setTwitter] = useSmartProp("twitter");
    const [theme, setTheme] = useSmartProp("theme");
    const [logoLink, setLogoLink] = useSmartProp("logoLink");

    return <><PanelBody title="Options" initialOpen={true}>
        <PanelRow>
            <ToggleControl
                label={theme ? 'Dark' : 'Light'}
                checked={theme}
                onChange={setTheme}
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Logo Link"
                value={logoLink}
                onChange={ setLogoLink }
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Copyright"
                value={copyright}
                onChange={ ( copyright ) => setCopyright(copyright) }
            />
        </PanelRow>
    </PanelBody>
    <PanelBody title="Socials Urls" initialOpen={true}>
        <PanelRow>
            <TextControl
                label="Linkedin"
                value={linkedin}
                onChange={ ( linkedin ) => setLinkedin(linkedin) }
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Youtube"
                value={youtube}
                onChange={ ( youtube ) => setYoutube(youtube) }
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Facebook"
                value={facebook}
                onChange={ ( facebook ) => setFacebook(facebook) }
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Twitter"
                value={twitter}
                onChange={ ( twitter ) => setTwitter(twitter) }
            />
        </PanelRow>
    </PanelBody></>
}

function Block({theme, custom_settings, phoneNumber, copyright, linkedin, youtube, facebook, twitter, menuLeftCustom, menuRightCustom, menuLegalCustom, logoLink}){
    useInspectorControl(Inspector);
    const {isEditing} = useEditor();
    const Wrapper = isEditing ? 'div':'a';

    const blockClasses = classnames({
        [style.block]: true,
        [style.lightTheme]: !theme
    })

    return <div className={blockClasses}>
                <div className={style.content}>    
                    <div className={style.logo}>
                        <a href={logoLink}>
                            <img src={Logo} alt="logo" width={170} height={65} />
                        </a>
                    </div> 
                        <div className={style.menu}><Menu smartProp="menuLeftCustom" /></div>
                        <div className={style.menu}><Menu smartProp="menuRightCustom" /></div>
                        <div className={style.contact}>
                            { isEditing ? 
                                <InnerBlocks
                                    allowedBlocks={["smartfire/air-liquide-button", "smartfire/button"]}
                                    templateLock={false}
                                />:
                                <div>
                                    <ChildrenBlock/>
                                </div>

                             }

                        <div className={style.social}>
                            {custom_settings ? custom_settings.linkedin && <a href={custom_settings.linkedin} target="_blank" rel="noopener noreferrer"><Linkedin /></a> : 
                                linkedin && <Wrapper href={linkedin} target="_blank" rel="noopener noreferrer"><Linkedin /></Wrapper> }
                            {custom_settings ? custom_settings.youtube && <a href={custom_settings.youtube} target="_blank" rel="noopener noreferrer"><Youtube /></a> : 
                                youtube && <Wrapper href={youtube} target="_blank" rel="noopener noreferrer"><Youtube /></Wrapper> }
                            {custom_settings ? custom_settings.facebook && <a href={custom_settings.facebook} target="_blank" rel="noopener noreferrer"><Facebook /></a> : 
                                facebook && <Wrapper href={facebook} target="_blank" rel="noopener noreferrer"><Facebook /></Wrapper> }
                            {custom_settings ? custom_settings.twitter && <a href={custom_settings.twitter} target="_blank" rel="noopener noreferrer"><Twitter /></a> : 
                                twitter && <Wrapper href={twitter} target="_blank" rel="noopener noreferrer"><Twitter /></Wrapper> }
                        </div>
                    </div>
                </div>
                <div className={style.contentSubFooter}>
                    <div className={style.topLine}>
                        <div className={style.contentLegal}>
                            <div>
                                {custom_settings ? custom_settings.copyright_footer : copyright }
                            </div>
                            <div className={style.right}>
                                <div className={style.menu}><Menu smartProp="menuLegalCustom" /></div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
}


export default defineBlock({
    Block, 
    smartProps: {
        copyright: smartProps.string.withDefault('copyright'),
        linkedin: smartProps.string.withDefault(),
        youtube: smartProps.string.withDefault(),
        facebook: smartProps.string.withDefault(),
        twitter: smartProps.string.withDefault(),
        menuLeftCustom: smartProps.any.withDefault([]),
        menuRightCustom: smartProps.any.withDefault([]),
        menuLegalCustom: smartProps.any.withDefault([]),
        theme: smartProps.bool.withDefault(true),
        logoLink: smartProps.bool.withDefault('/')
    },
    setup: {
        title: "Footer Page template",
        category: "two-third"
    }
})